import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ReceiptIcon from '@material-ui/icons/Receipt';
import EmailIcon from '@material-ui/icons/Email';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TablePagination, TableRow, Paper,Button,Badge,Chip,Box
} from '@material-ui/core';
import { Dialog, DialogContent, DialogActions, Typography, CircularProgress, IconButton } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
  import { useNavigate, useLocation } from 'react-router-dom';

import {ProcessInvoice,SendEmail} from '../../../adminModel/auctions'
const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: 440,
  },
});


const renderStatusBadge = (status) => {
  const getBadgeStyle = (color) => ({
    backgroundColor: color,
    color: '#fff',
    padding: '4px 12px',
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: 500,
  });

  switch (status) {
    case 'DRAFT':
      return (
        <Badge
          badgeContent={
            <span style={getBadgeStyle('#bdbdbd')}>DRAFT</span>
          }
        >
          <span></span>
        </Badge>
      );
    case 'SENT':
      return (
        <Badge
          badgeContent={
            <span style={getBadgeStyle('#1976d2')}>SENT</span>
          }
        >
          <span></span>
        </Badge>
      );
    case 'PAID':
      return (
        <Badge
          badgeContent={
            <span style={getBadgeStyle('#388e3c')}>PAID</span>
          }
        >
          <span></span>
        </Badge>
      );
    case 'CANCELLED':
      return (
        <Badge
          badgeContent={
            <span style={getBadgeStyle('#d32f2f')}>CANCELLED</span>
          }
        >
          <span></span>
        </Badge>
      );
    default:
      return (
        <Badge
          badgeContent={
            <span style={getBadgeStyle('#9e9e9e')}>No Invoice</span>
          }
        >
          <span></span>
        </Badge>
      );
  }
};

export default function View({ className, winner, id,onRefresh, ...rest }) {
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
const [mailloading, setmailLoading] = React.useState(false);
const [mailsuccess, setmailSuccess] = React.useState(false);
const [message, setMessage] = React.useState('Sending...');
const handleSend = async (id) => {
  setmailLoading(true);           // Show loading
  setMessage('Sending...');   // Set initial message
  setmailSuccess(false);          // Hide success

  try {
    const process = await SendEmail(id);

    if (process.success) {
      setMessage('Invoice sent successfully!');
      await onRefresh();
      setmailSuccess(true);
    } else {
      console.error(process);
      setMessage('Failed to send invoice.');
    }

  } catch (error) {
    console.error(error);
    setMessage('An error occurred while sending.');
  } finally {
    // Hide loader after a short delay to allow user to read the message
    setTimeout(() => {
      setmailLoading(false);
    }, 1000);
  }
};

  const handleProcess = async (id) => {
    setLoading(true);
    setSuccess(false);
    try {
      
      const process = await ProcessInvoice(id);
  
      if (process.success){
          await onRefresh()
           setSuccess(true);  // Show success modal
      }else{
          console.error(process);
           setSuccess(false);  // Show success modal
      }
     
    } catch (error) {
      console.error(error);
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSuccess = () => {
    setSuccess(false);
    
  };

  return (
    <>
    {/* Sending Modal */}
<Dialog open={mailloading} PaperProps={{ style: { padding: '20px', textAlign: 'center' } }}>
  <DialogContent>
    <CircularProgress />
    <Typography variant="h6" style={{ marginTop: 16 }}>
      {message}
    </Typography>
  </DialogContent>
</Dialog>

{/* Success Modal */}
<Dialog open={mailsuccess} onClose={() => setmailSuccess(false)} PaperProps={{ style: { padding: '20px', textAlign: 'center' } }}>
  <DialogActions style={{ justifyContent: 'flex-end' }}>
    <IconButton onClick={() => setmailSuccess(false)}>
      <CloseIcon />
    </IconButton>
  </DialogActions>
  <DialogContent>
    <CheckCircleIcon style={{ fontSize: 60, color: 'green' }} />
    <Typography variant="h6" style={{ marginTop: 16 }}>
      Invoice Sent Successfully!
    </Typography>
  </DialogContent>
</Dialog>

      {/* Loading Modal */}
      <Dialog open={loading} PaperProps={{ style: { padding: '20px', textAlign: 'center' } }}>
        <DialogContent>
          <CircularProgress />
          <Typography variant="h6" style={{ marginTop: 16 }}>
            Processing...
          </Typography>
        </DialogContent>
      </Dialog>

      {/* Success Modal */}
      <Dialog open={success} onClose={handleCloseSuccess} PaperProps={{ style: { padding: '20px', textAlign: 'center' } }}>
        <DialogActions style={{ justifyContent: 'flex-end' }}>
          <IconButton onClick={handleCloseSuccess}>
            <CloseIcon />
          </IconButton>
        </DialogActions>
        <DialogContent>
          <CheckCircleIcon style={{ fontSize: 60, color: 'green' }} />
          <Typography variant="h6" style={{ marginTop: 16 }}>
            Invoice Processed Successfully!
          </Typography>
        </DialogContent>
      </Dialog>

      <Paper style={{ width: '100%', overflow: 'hidden' }}>
        
        <Box display="flex" justifyContent="flex-end" gap={1} padding={1}>
          <Button
            style={{ marginRight: 5 }}
            variant="contained"
            color="primary"
            size="small"
            startIcon={<ReceiptIcon />}
            onClick={() => handleProcess(id)}
          >
            Process Invoice
          </Button>

          <Button
            variant="contained"
            color="secondary"
            size="small"
            startIcon={<EmailIcon />}
             onClick={() => handleSend(id)}
          >
            Send Email
          </Button>
        </Box>
        <TableContainer>
          <Table stickyHeader aria-label="auction table">
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Client Name</TableCell>
                <TableCell align="">Email</TableCell>
                <TableCell align="">Lots</TableCell>
                <TableCell align="">Status</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {
              
              winner.map((data, index) => {
                
                return (
                  <TableRow key={index} hover>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{data.client_name}</TableCell>
                    <TableCell align="">{data.email}</TableCell>
                    <TableCell align="">{data.lot_number}</TableCell>
                    <TableCell align="">{renderStatusBadge(data.status)}</TableCell>
                  </TableRow>
                );
                
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
}
